"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var ControlledCheckbox = /** @class */ (function (_super) {
    tslib_1.__extends(ControlledCheckbox, _super);
    function ControlledCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlledCheckbox.prototype.updateField = function (event) {
        var attributes = {};
        attributes[this.props.fieldName] = event.target.checked;
        this.props.updateField(attributes);
    };
    ControlledCheckbox.prototype.render = function () {
        return (React.createElement("input", { name: this.props.inputName, type: "checkbox", id: this.props.id || this.props.inputName, checked: this.props.checked, onChange: this.updateField, required: this.props.required, disabled: this.props.disabled, defaultChecked: this.props.defaultChecked }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ControlledCheckbox.prototype, "updateField", null);
    return ControlledCheckbox;
}(React.Component));
exports.default = ControlledCheckbox;
//# sourceMappingURL=controlled_checkbox.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/controlled_checkbox.js
// module id = Keyz
// module chunks = 20 21 22